/**
 * Keep Shopify Markets currency/country when navigating hardcoded /products or /collections links.
 * Rewrites root-relative storefront URLs to include Shopify.routes.root (e.g. /en-be/).
 */
(function () {
  function marketRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (!root.startsWith('/')) root = '/' + root;
    if (!root.endsWith('/')) root += '/';
    return root;
  }

  /** Fix /en-beproducts/... → /en-be/products/... when root had no trailing slash */
  function repairBrokenMarketPath(pathname) {
    if (!pathname || typeof pathname !== 'string' || !pathname.startsWith('/')) return pathname;

    // Pattern match even on 404 pages where Shopify.routes.root may be `/`
    var glued = pathname.match(
      /^\/([a-z]{2}(?:-[a-z]{2})?)(products|collections|pages|cart|account|search|blogs|policies)(\/|$)/i
    );
    if (glued) {
      return (
        '/' +
        glued[1].toLowerCase() +
        '/' +
        glued[2].toLowerCase() +
        pathname.slice(('/' + glued[1] + glued[2]).length)
      );
    }

    var root = marketRoot();
    if (root === '/') return pathname;
    var rootNoSlash = root.slice(0, -1);
    if (pathname.startsWith(rootNoSlash) && !pathname.startsWith(root)) {
      var rest = pathname.slice(rootNoSlash.length);
      if (rest && rest.charAt(0) !== '/') {
        return root + rest;
      }
    }
    return pathname;
  }

  function localizePath(pathname) {
    if (!pathname || typeof pathname !== 'string') return pathname;
    if (!pathname.startsWith('/')) return pathname;

    pathname = repairBrokenMarketPath(pathname);

    var root = marketRoot();
    if (root === '/') return pathname;

    // Already under current market root
    if (pathname === root.slice(0, -1) || pathname.startsWith(root)) return pathname;

    // Only rewrite storefront paths that would otherwise fall back to the primary market
    if (
      !/^\/(products|collections|pages|cart|account|search|blogs|policies)(\/|$)/i.test(pathname)
    ) {
      return pathname;
    }

    return root + pathname.replace(/^\//, '');
  }

  function localizeHref(href) {
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
      return href;
    }
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return href;
      var nextPath = localizePath(url.pathname);
      if (nextPath === url.pathname) return href;
      return nextPath + url.search + url.hash;
    } catch (e) {
      return href;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var anchor = event.target.closest && event.target.closest('a[href]');
      if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return;
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      var href = anchor.getAttribute('href');
      var localized = localizeHref(href);
      if (localized && localized !== href) {
        anchor.setAttribute('href', localized);
      }
    },
    true
  );

  // Product JSON / section fetches that hardcode /products/...
  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        if (typeof input === 'string') {
          input = localizeHref(input);
        } else if (input && typeof Request !== 'undefined' && input instanceof Request) {
          var next = localizeHref(input.url);
          if (next !== input.url) {
            input = new Request(next, input);
          }
        }
      } catch (e) {
        /* keep original */
      }
      return nativeFetch(input, init);
    };
  }

  window.llLocalizePath = localizePath;
  window.llLocalizeHref = localizeHref;

  // If the current URL is already broken (/en-beproducts/...), fix it immediately
  try {
    var fixedPath = repairBrokenMarketPath(window.location.pathname);
    if (fixedPath && fixedPath !== window.location.pathname) {
      window.location.replace(fixedPath + window.location.search + window.location.hash);
    }
  } catch (e) {
    /* ignore */
  }
})();
